import React from 'react'

export default props =>
  props.isNew ? (
    <svg
      width="21"
      height="21"
      {...props}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M5.38948 7.984H4.45648C2.42148 7.984 0.771484 9.634 0.771484 11.669L0.771484 16.544C0.771484 18.578 2.42148 20.228 4.45648 20.228H15.5865C17.6215 20.228 19.2715 18.578 19.2715 16.544V11.659C19.2715 9.63 17.6265 7.984 15.5975 7.984L14.6545 7.984"
          stroke="#273754"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0215 1.19051V13.2315"
          stroke="#273754"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.10645 4.1188L10.0214 1.1908L12.9374 4.1188"
          stroke="#273754"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ) : (
    <svg viewBox="0 0 14 17" {...props}>
      <path d="M4,13 L10,13 L10,7 L14,7 L7,0 L0,7 L4,7 L4,13 Z M0,15 L14,15 L14,17 L0,17 L0,15 Z" />
    </svg>
  )
